export const DiscountCampaigns: Record<string, string> = {
  DE_Becas: "ZUSCHUSS100",
  ES_Becas: "BECA60",
  FR_Becas: "AIDE150",
  FR_Becas_90: "TRUFFE90",
  IT_Becas: "CONTRIBUTO90",
  PT_Becas: "SUBSIDIO60",
  GR_Becas: "PetHealth60",
  FI_Becas: "Alennus120",
  ES_Becas_compressed: "DESCUENTO60",
  ES_Becas_tenure_save60: "BONO60",
  ES_Becas_tenure_save40: "BONO40",
};
